import { IconProps } from ".";

export const MagicBookIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 4.75C4 3.23122 5.23122 2 6.75 2H19.25C19.6642 2 20 2.33579 20 2.75V21.25C20 21.6642 19.6642 22 19.25 22H6.75C5.23122 22 4 20.7688 4 19.25C4 19.1948 4.00163 19.14 4.00483 19.0856C4.00164 19.0575 4 19.0289 4 19V4.75ZM5.5 19.25C5.5 19.9404 6.05964 20.5 6.75 20.5H18.5V18H6.75C6.05964 18 5.5 18.5596 5.5 19.25ZM18.5 16.5H6.75C6.29989 16.5 5.87503 16.6081 5.5 16.7999V4.75C5.5 4.05964 6.05964 3.5 6.75 3.5H18.5V16.5Z"
        fill="currentColor"
        style={{ fill: "currentColor", fillOpacity: "1" }}
      />
      <path
        d="M12.1845 7.40787C12.2813 7.35949 12.3598 7.28103 12.4081 7.18426L13.0531 5.89443C13.2373 5.5259 13.7632 5.5259 13.9475 5.89443L14.5924 7.18426C14.6408 7.28103 14.7192 7.35949 14.816 7.40787L16.1058 8.05279C16.4744 8.23705 16.4744 8.76295 16.1058 8.94721L14.816 9.59213C14.7192 9.64051 14.6408 9.71897 14.5924 9.81574L13.9475 11.1056C13.7632 11.4741 13.2373 11.4741 13.0531 11.1056L12.4081 9.81574C12.3598 9.71897 12.2813 9.64051 12.1845 9.59213L10.8947 8.94721C10.5262 8.76295 10.5262 8.23705 10.8947 8.05279L12.1845 7.40787Z"
        fill="currentColor"
        style={{ fill: "currentColor", fillOpacity: "1" }}
      />
      <path
        d="M8.5775 11.7114C8.63556 11.6824 8.68263 11.6353 8.71166 11.5772L9.23194 10.5367C9.3425 10.3155 9.65804 10.3155 9.7686 10.5367L10.2889 11.5772C10.3179 11.6353 10.365 11.6824 10.423 11.7114L11.4636 12.2317C11.6847 12.3422 11.6847 12.6578 11.4636 12.7683L10.423 13.2886C10.365 13.3176 10.3179 13.3647 10.2889 13.4228L9.7686 14.4633C9.65804 14.6845 9.3425 14.6845 9.23195 14.4633L8.71166 13.4228C8.68263 13.3647 8.63556 13.3176 8.5775 13.2886L7.53693 12.7683C7.31582 12.6578 7.31581 12.3422 7.53693 12.2317L8.5775 11.7114Z"
        fill="currentColor"
        style={{ fill: "currentColor", fillOpacity: "1" }}
      />
    </svg>
  );
};
